import React, { useEffect, useMemo } from 'react'
import { Button } from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import { isEmpty } from 'ramda'
import config from '../../../config.json'
import $t from '../../../i18n'
import Actions from '../../../actions'
import { useLocation } from 'react-router'
import { routes } from '../../../consts'
import Page from '../../common/Page'

import './SelectedLabFacility.css'
import { getIsHmoMember } from '../../../utils/hmoUtils'

const SelectedLabFacility = () => {
  const dispatch = useDispatch()
  const referralFacilityError = useSelector(
    state => state.medicalInfo?.referralFacilityError
  )
  const userDetails = useSelector(state => state.profile?.userDetails)
  const { search } = useLocation()
  const searchParams = useMemo(() => new URLSearchParams(search), [search])
  const location = searchParams.get('location')
  const order = searchParams.get('order')

  const referralFacility = useSelector(
    state => state.medicalInfo?.referralFacility
  )

  const isFacilityLoaded = isEmpty(referralFacility)

  const openGetDirections = () => {
    const latLng = `${referralFacility?.latitude},${referralFacility?.longitude}`
    const url = `https://maps.google.com/?q=${latLng}`
    window.open(url, '_blank')
  }

  const openGetInstructions = () => {
    getIsHmoMember(userDetails)
      ? window.open(config.questHMOInstructionsUrl, '_blank')
      : window.open(config.questInstructionsUrl, '_blank')
  }

  useEffect(() => {
    dispatch(
      Actions.createAction(Actions.SELECTED_LAB_FACILITY_LOCATION_REQUESTED, {
        locationId: location,
        orderId: order,
      })
    )
  }, [])

  useEffect(() => {
    if (referralFacilityError) {
      dispatch(
        Actions.createAction(Actions.NAVIGATED_TO, routes.MENU_ROUTE.REFERRALS)
      )
    }
  }, [referralFacilityError])

  const shouldShowPrice = () => {
    return referralFacility?.price && !getIsHmoMember(userDetails)
  }

  return (
    <Page
      className="selected-lab-facility-page"
      title={$t('labFacility.title')}
      subtitle={$t('labFacility.arriveFacilityMessage')}
      loading={isFacilityLoaded}
    >
      <div className="selected-lab-facility-body">
        <div className="selected-lab-facility-body-container">
          <div className="facility-title">
            {referralFacility?.facility_name}
          </div>
          <div className="facility-address">
            {referralFacility?.full_address} <br /> {referralFacility?.phone}
          </div>
          {shouldShowPrice() && (
            <div className="facility-price-container">
              <span className="facility-price">${referralFacility?.price}</span>
              <span className="facility-price-desc">
                {$t('labFacility.estPrice')}
              </span>
            </div>
          )}
        </div>
      </div>
      <div className="facility-actions-container">
        <Button
          onClick={openGetDirections}
          data-name="get_directions_clicked_sow"
          type="primary"
          className="trackable"
        >
          {$t('labFacility.getDirections')}
        </Button>
        <Button
          data-name="instructions_clicked_sow"
          onClick={openGetInstructions}
          type="link"
          className="facility-actions-desc trackable"
        >
          {$t('labFacility.instructions')}
        </Button>
      </div>
    </Page>
  )
}

export default SelectedLabFacility
